export default __webpack_public_path__ + "static/media/01.c51d109e.jpg";